import React from "react";
import styled from "styled-components";
import settings from "../../../settings";

export const Frame = styled.div`
	display: flex;
	align-items: center;
`;

export const Dot = styled.a<{
	isActive: boolean;
	onClick: (index: number) => void;
}>`
	display: block;
	text-decoration: none;
	width: 1rem;
	height: 1rem;
	background-color: ${(props) =>
		props.isActive ? settings.color.accent : settings.color.darkGray};
	border-radius: 100%;
	& + & {
		margin-left: 1rem;
	}
`;
